<template>
  <div v-frag class="prism-elite-app">
    <CardIeaAppMain colorCard="#0F172A" title="">
      <v-col cols="12" class="pa-0 main-container-glass">
        <!-- Top Bar -->
        <div class="prism-top-bar d-flex align-center justify-space-between px-8 py-5">
           <div class="d-flex align-center">
            <v-btn
              icon
              @click="$router.push({ name: 'Home' })"
              class="mr-4 glass-btn"
              large
            >
              <v-icon color="primary">mdi-arrow-left-circle-outline</v-icon>
            </v-btn>
             <div>
              <h1 class="text-h6 font-weight-black prism-title mb-0">Documentación del Alumno</h1>
              <div class="text-caption grey--text font-weight-medium">Requisitos Legales y Faltantes</div>
            </div>
           </div>
        </div>

        <v-divider class="prism-divider"></v-divider>

        <v-row class="pa-8">
          <v-col cols="12">
            <div class="d-flex align-center justify-space-between mb-8">
               <div>
                  <h2 class="text-h5 font-weight-black prism-heading">Listado de Documentos</h2>
                  <p class="text-caption grey--text mb-0">Gestione y valide su legajo académico acá.</p>
               </div>
               <v-chip class="font-weight-black px-4" color="primary" outlined>
                  {{ documentos.length }} TOTAL
               </v-chip>
            </div>

            <v-row>
               <v-col v-for="(element, index) in documentos" :key="index" cols="12" md="6" lg="4">
                  <v-card flat class="rounded-xl glass-card-interactive overflow-hidden h-full d-flex flex-column">
                     <div class="pa-6 flex-grow-1">
                        <div class="d-flex justify-space-between align-start mb-4">
                           <v-avatar size="48" :color="getStatusColor(element) + ' lighten-5'" class="elevation-0">
                              <v-icon :color="getStatusColor(element)" size="24">
                                {{ element.validado ? 'mdi-check-decagram' : (element.entregado ? 'mdi-file-eye-outline' : 'mdi-file-alert-outline') }}
                              </v-icon>
                           </v-avatar>
                           <v-chip
                             small
                             :color="getStatusColor(element)"
                             dark
                             class="font-weight-black px-3"
                           >
                             {{ element.validado ? 'VALIDADO' : (element.entregado ? 'ENTREGADO' : 'FALTANTE') }}
                           </v-chip>
                        </div>

                        <div class="text-h6 font-weight-black mb-2">{{ element.documento }}</div>
                        <div class="text-body-2 grey--text mb-6">
                          {{ element.validado ? 'Su documento ha sido verificado por secretaría.' : (element.entregado ? 'Documento recibido. Pendiente de validación.' : 'Este documento es obligatorio para completar su inscripción.') }}
                        </div>

                        <!-- Sub-documents / Uploaded Files -->
                        <div v-if="element.documentos.length > 0" class="elite-docs-strip pa-3 rounded-xl mb-4">
                           <div v-for="(docElement, docIndex) in element.documentos" :key="docIndex" class="d-flex align-center justify-space-between py-2 border-bottom-soft last-no-border">
                              <div class="d-flex align-center">
                                 <v-icon small color="grey" class="mr-2">mdi-file-image-outline</v-icon>
                                 <span class="text-tiny font-weight-bold grey--text text--darken-2">{{ docTitle(docIndex) }}</span>
                              </div>
                               <div class="d-flex">
                                  <v-btn v-if="docElement && docElement.documento_imagen" icon x-small color="primary" class="mr-1" :href="docElement.documento_imagen.imagen" target="_blank" title="Ver archivo">
                                     <v-icon small>mdi-eye</v-icon>
                                  </v-btn>
                                  <v-btn icon x-small color="info" class="mr-1" v-if="docElement && docElement.documento_completo && !element.validado" @click="uploadFile(docElement.documento_completo.IDF)" title="Modificar">
                                     <v-icon small>mdi-pencil</v-icon>
                                  </v-btn>
                                  <v-btn v-if="docElement && docElement.documento_imagen && !element.validado" icon x-small color="error" @click="deleteDocumento(docElement.documento_imagen.IDVReg)" title="Eliminar">
                                     <v-icon small>mdi-delete</v-icon>
                                  </v-btn>
                               </div>
                           </div>
                        </div>

                        <!-- Upload Button for Missing / Slotted -->
                        <div v-if="element.documentos.length < 2 && !element.validado && element.id != 10" class="mt-auto">
                           <v-btn
                             v-for="btnElement in docCount(element.documentos)"
                             :key="btnElement"
                             block
                             outlined
                             color="success"
                             class="rounded-xl font-weight-black mb-2"
                             @click="uploadFile(element.documento_completo.IDF)"
                           >
                             <v-icon left>mdi-cloud-upload-outline</v-icon>
                             SUBIR {{ docTitle(element.documentos.length + btnElement - 1) }}
                           </v-btn>
                        </div>
                     </div>
                  </v-card>
               </v-col>
            </v-row>
          </v-col>
        </v-row>

        <input id="file-upload" type="file" v-on:change="addDocument()" ref="fileInput" class="inputUpload" style="display:none" />
      </v-col>
    </CardIeaAppMain>
  </div>
</template>


<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Outfit:wght@700;900&display=swap");

.prism-elite-app {
  font-family: "Inter", sans-serif !important;
  background: radial-gradient(circle at 0% 0%, #0f172a 0%, #1e293b 100%);
  min-height: 100vh;
}

h1, h2, h3, .prism-heading, .text-overline {
  font-family: "Outfit", sans-serif !important;
  letter-spacing: -0.5px;
}

.main-container-glass {
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(20px);
  min-height: 90vh;
}

.prism-top-bar { background: transparent; }
.prism-divider { border-color: rgba(0,0,0,0.05) !important; }

/* Elite Cards */
.glass-card-interactive {
  background: white;
  border: 1px solid #f1f5f9 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05) !important;
}
.glass-card-interactive:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px -15px rgba(0, 0, 0, 0.1) !important;
  border-color: #e2e8f0 !important;
}

/* Docs Strip */
.elite-docs-strip {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.border-bottom-soft {
  border-bottom: 1px solid #f1f5f9;
}
.last-no-border:last-child {
  border-bottom: none;
}

.text-tiny { font-size: 0.75rem !important; }
.uppercase { text-transform: uppercase; }

.h-full { height: 100%; }

@media (min-width: 1264px) {
  .sticky-card {
    position: sticky;
    top: 20px;
  }
}
</style>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Documento",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
  },

  data: () => ({
    title:"Documentos faltantes",
    selected:'',
    documentos:[],  
  }),

  methods: {
    getStatusColor(element) {
      if (element.entregado && element.validado) {
        return 'orange'; // Validado
      } else if (element.entregado) {
        return 'green'; // Entregado
      } else {
        return 'red'; // Faltante
      }
    },
    async uploadFile(tipo_documento_id) {
      this.selected = tipo_documento_id;     
      this.$refs.fileInput.click()   
    },

    docTitle(index){
      return "Documento " + (index+1);
    },

    docCount(docList){
      return 2 - docList.length; //correccion aparecen dos botones de subir documentos 
    },

    async addDocument() {
      var formData = new FormData();
      formData.append('tipo_documento_id', this.selected);
      formData.append('image', this.$refs.fileInput.files[0]);

      let url = "alumno-documentos/upload";
      await this.$API
        .post({
          url: url,
          data: formData
        }).then(() => {
          this.$refs.fileInput.value = null;
          this.loadDocumentos();
        });
    },

    async deleteDocumento(id) {
      if(confirm('¿Estas seguro de eliminar este documento?')){
        let url = "alumno-documentos/delete/" + id;
        await this.$API
          .post({
            url: url,
          }).then(() => {
            this.loadDocumentos();
          });
      }
    },
    async loadDocumentos() {
      let url = "documentos/index";
      await this.$API
        .get({
          url: url
        }).then((res) => {
          this.documentos = res.documentos;
        });
    }
  },

   mounted() {
    if(this.$store.getters.user.borrado == 1 ||  this.$store.getters.user.alumno_mora ==  true){
      this.$router.push({
          name: "Home"
        });
    }
    this.$API
      .get({
        url: "documentos/index"
      }).then((res) => {
        this.documentos = res.documentos;
      });
  },
};
</script>
